import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const { pathname, search, hash } = useLocation();

  useEffect(() => {
    if ("scrollRestoration" in window.history) {
      window.history.scrollRestoration = "manual";
    }
  }, []);

  useEffect(() => {
    if (hash && hash !== "#rooms" && hash !== "#review") {
      const id = hash.replace("#", "");
      const element = document.getElementById(id);
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
        return;
      }
    }

    // Immediately scroll to top
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    if (document.body) document.body.scrollTop = 0;
    if (document.documentElement) document.documentElement.scrollTop = 0;

    // Catch any late lazy-load chunk layout shifts
    const raf = requestAnimationFrame(() => {
      window.scrollTo(0, 0);
      if (document.body) document.body.scrollTop = 0;
      if (document.documentElement) document.documentElement.scrollTop = 0;
    });

    return () => cancelAnimationFrame(raf);
  }, [pathname, search, hash]);

  return null;
}

export default ScrollToTop;
